import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as S from './styled'

const debugBarContainer = document.querySelector('#debugBarContainer')

const DebugBar = ({ isOpened, onClose, children }) => {
  return isOpened
    ? ReactDOM.createPortal(
        <S.DebugBarContainer tabIndex='-1' role='dialog'>
          <S.DebugBarDialog role='document'>
            <S.DebugBarContent>{children}</S.DebugBarContent>
          </S.DebugBarDialog>
        </S.DebugBarContainer>,
        debugBarContainer
      )
    : null
}

DebugBar.defaultProps = {
  isOpened: false,
  onClose: () => {},
  children: [],
}

DebugBar.propTypes = {
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.array,
}

export default DebugBar
